import { render, staticRenderFns } from "./OptimizationHint.vue?vue&type=template&id=2d90866c&scoped=true&"
import script from "./OptimizationHint.vue?vue&type=script&lang=ts&"
export * from "./OptimizationHint.vue?vue&type=script&lang=ts&"
import style0 from "./OptimizationHint.vue?vue&type=style&index=0&id=2d90866c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d90866c",
  null
  
)

export default component.exports